module.exports = __webpack_public_path__ + "img/contact-img.537ed1cf.jpg";